import axios from 'axios'

axios.defaults.withCredentials = true

const httpClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "Content-Type": "application/json",   
    }
});

export default httpClient;